/**
 * RESPONSIBILITY: match a Visit section's template to the component that draws it.
 *
 * A lookup and not a `switch`: a new template is a key here and a file beside it. A band
 * saved with NO template is the original one - see visit-themes.ts - which is what makes
 * the page draw exactly as it did before templates. A template this build has never heard
 * of draws nothing rather than throwing: that is a deployment mid-flight, not a reason to
 * show a visitor a blank page.
 */
import { VISIT_THEME as T, DEFAULT_VISIT_THEME, type VisitBand } from '@app/sections';
import {
  text, image, imageLeft, imageRight, imageTop, textTop, facts, cta, location, faq, video, gallery,
  type BandDef,
} from '../../commons/bands';
import { visitAlternating } from './BandVisitAlternating';

const BANDS: Record<string, BandDef> = {
  [T.Alternating]: visitAlternating,
  [T.Text]: text,
  [T.Image]: image,
  [T.ImageLeft]: imageLeft,
  [T.ImageRight]: imageRight,
  [T.ImageTop]: imageTop,
  [T.TextTop]: textTop,
  [T.Facts]: facts,
  [T.Cta]: cta,
  [T.Location]: location,
  [T.Faq]: faq,
  [T.Video]: video,
  [T.Gallery]: gallery,
};

export const visitBandOf = (b: VisitBand): BandDef | undefined => BANDS[b.theme || DEFAULT_VISIT_THEME];
